// extracted by mini-css-extract-plugin
export default {"header":"Header_header__thnQ9","container":"Header_container__sdRQM","logo":"Header_logo__yeqsS","subject":"Header_subject__47Dg4"};